import { Component, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Component({
    selector: 'app-store-layout',
    templateUrl: './store-layout.component.html',
    styleUrls: ['./store-layout.component.scss'],
    standalone: false
})
export class StoreLayoutComponent implements OnInit {

  constructor(@Inject(PLATFORM_ID) private platformId: Object) { }

  ngOnInit() {
  }

  isBrowser() {
    return isPlatformBrowser(this.platformId);
  }
}
